import React from 'react';

import * as FontAwesome from 'react-icons/fa';
import * as Io5Icons from 'react-icons/io5';

const iconPacks = {
  fa: FontAwesome,
  io5: Io5Icons,
};

export default function DynamicIcon({ iconPack = 'fa', iconName, className }) {
  const icons = iconPacks[iconPack];
  const IconComponent = icons[iconName];

  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found in pack "${iconPack}"`);
    return null;
  }

  return <IconComponent className={className} />;
}
